import React from 'react';

export const LogInSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M3 12a1 1 0 0 0 1 1h6c.681 0 1.478-.116 2.234-.269l.143.143a1 1 0 0 1-.149.11c-.818.496-1.748 1.126-2.384 1.758l-.551.55a1 1 0 0 0 1.408 1.421l4.006-4.006a1 1 0 0 0 0-1.414l-4-4A1 1 0 0 0 9.29 8.704l.003.003.535.536c.638.637 1.575 1.273 2.4 1.774q.081.049.15.109l-.144.143C11.478 11.116 10.68 11 10 11H4a1 1 0 0 0-1 1"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13 4a1 1 0 0 1 1-1h3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4h-3a1 1 0 1 1 0-2h3a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3a1 1 0 0 1-1-1"
            clipRule="evenodd"
        />
    </svg>
);
